import { Leaf } from 'lucide-react';

import { Text } from '@/components/text';
import { EmissionStats } from '@/types';
import { formatEmissionsRangeString } from '@/utils/format/emissions';

export interface EmissionsStatementProps {
  label?: string;
  emissions: EmissionStats;
}

const EmissionsStatement = ({ label = 'Emissions', emissions }: EmissionsStatementProps) => {
  return (
    <>
      <Text variant="sm" className="m-0 mb-1 text-grey-600">
        {label}
      </Text>
      <div className="flex items-center">
        <Leaf size={14} className="mr-1 fill-green-300" />
        <Text variant="secondary" className="m-0 font-medium">
          {formatEmissionsRangeString(emissions, true)}
        </Text>
      </div>
    </>
  );
};

export { EmissionsStatement };
